export const colorNames = () => {
    return {
        themeColor: "rgb(252, 103, 54)",
        authBackground: {
            gradientStart: "rgb(225, 224, 234)",
            gradientMid1: "rgb(255, 255, 108)",
            gradientMid2: "rgb(255, 199, 108)",
            gradientMid3: "rgb(252, 103, 54)"
        },
        authColors: {
            textColor: "rgb(0, 0, 0)",
            whiteColor: "rgb(255, 255, 255)",
            boxBackground: "rgba(255,255,255,0.15)",
            squareBackground: "rgba(255,255,255,0.1)",
            boxShadow: "rgba(0,0,0,0.1)",
            boxBorder: "rgba(255,255,255,0.4)",
            boxBorderAlt: "rgba(255,255,255,0.2)",
            inputBorder: "rgb(125, 125, 125)",
            inputLabelColor: "rgb(88, 88, 88)",
        },
        boxShadowColors: {
            shadowColor1: "rgba(0, 0, 0, 0.14)",
            shadowColor2: "rgba(50, 50, 50, 0.09)",
            shadowColor3: "rgba(0, 0, 0, 0.4)"
        },
        customColors: {
            blackColor: "rgb(0, 0, 0)",
            blackColor1: "rgb(68, 68, 68)",
            blackColor2: "rgb(126, 126, 126)",
            blackColor3: "rgb(194, 194, 194)",
            whiteColor: "rgb(255, 255, 255)",
            whiteColor1: "rgba(255, 255, 255, 0.8)",
            whiteColor2: "rgba(203, 203, 203, 0.6)",
            lightBackground: "rgb(243, 243, 243)",
            lightBackground1: "rgba(255, 255, 255, 0.2)",
            lightBackground2: "rgb(218, 218, 218)",
            lightBackground3: "rgb(224, 224, 224)",
            lightBackground4: "rgb(250, 250, 250)",
            borderColor: "rgb(225, 224, 234)",
            borderColor1: "rgb(201, 201, 201)",
            redColor: "rgb(255, 0, 0)",
            redColorLight: "rgba(255, 0, 0, 0.15)",
            orangeColor: "rgb(252, 103, 54)",
            orangeColorLight: "rgb(255, 143, 106)",
            greenColor: "rgb(63, 228, 79)",
            greenColorLight: "rgba(63, 228, 79, 0.15)",
            yellowColor: "rgb(255, 199, 108)",
            yellowColorLight: "rgba(255, 199, 108, 0.2)",
            blueColor: "rgb(2, 192, 255)",
            blueColorLight: "rgba(2, 192, 255, 0.08)",
            pinkColor: "rgb(255, 51, 161)",
        }
    };
}